export default function ToggleLanguage() {
  const toggle = $('.c-toggle')
  const toggleInput = toggle.find('input.c-toggle__input')

  const init = () => {
    const language = window.location.href.includes("/mi") ? "mi" : "en"

    if (language === "mi") {
      toggleInput.addClass("active")
    }


    toggle.on('click', function() {
      const t = $(this)
      const toggleInput = t.find('input.c-toggle__input')
      const checked = toggleInput[0].checked
      const enLink = $('a.en_NZ')[0];
      const miLink = $('a.mi_NZ')[0];
      if (!window.location.pathname.includes("/en/") && !window.location.pathname.includes("/mi/") ) {
        window.location.href = miLink.href
      } else {
        if (checked) {
          if (window.location.pathname.length > 1) {
            if (window.location.href.includes("/en")) {
              window.location.href = miLink.href
            }
          } else {
            window.location.href = miLink.href
          }
        } else {
          if (window.location.pathname.length > 1) {
            if (window.location.href.includes("/mi")) {
              window.location.href = enLink.href
            }
          } else {
            window.location.href = enLink.href
          }
        }
      }
      toggleInput.toggleClass("active")
    })
  }

  return {
    init: init,
  }
}
